import React from 'react'
import { generatePath } from 'react-router-dom'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { TransactionLinksDto } from 'api/Transaction/Types/TransactionLinksDto'
import { Link } from 'components/Link'

interface Props {
  data: TransactionDto
}

export const LinkedTransactionTable: React.FC<Props> = ({ data }) => {
  const results: TransactionLinksDto[] = [
    ...new Set(([] as TransactionLinksDto[]).concat(...data.linkedFrom, ...data.linkedTo)),
  ]
  return (
    <Grid data={results} resizable style={{ margin: 36 }}>
      <Column
        cell={(props: GridCellProps) => {
          if (data.id === props.dataItem.sourceTransaction.id) {
            return <td>{props.dataItem.sourceTransaction.name}</td>
          }
          return (
            <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
              <Link
                to={{
                  pathname: generatePath('/transactions/:id', {
                    id: props.dataItem.sourceTransaction.id,
                  }),
                }}
              >
                {props.dataItem.sourceTransaction.name}
              </Link>
            </td>
          )
        }}
        field='sourceTransaction.name'
        title='Source Transaction'
      />
      <Column
        cell={(props: GridCellProps) => {
          if (data.id === props.dataItem.targetTransaction.id) {
            return <td>{props.dataItem.targetTransaction.name}</td>
          }
          return (
            <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
              <Link
                to={{
                  pathname: generatePath('/transactions/:id', {
                    id: props.dataItem.targetTransaction.id,
                  }),
                }}
              >
                {props.dataItem.targetTransaction.name}
              </Link>
            </td>
          )
        }}
        field='targetTransaction.name'
        title='Target Transaction'
      />
    </Grid>
  )
}
